<div
  #messagesContainer
  class="messages">
  @if (messages().length === 0 && !isReplying() && emptyChatText()) {
    <p class="empty-chat-text">{{ emptyChatText() }}</p>
  }
  @for (message of messages(); track message.id) {
    <div
      class="message"
      [class.from-user]="message.role === 'user'">
      @if (message.role === 'assistant') {
        <div class="avatar assistant"></div>
      }
      @if (message.role === 'assistant' && assistantMessage(); as customContent) {
        <div class="bubble">
          <ng-container
            [ngTemplateOutlet]="customContent.template"
            [ngTemplateOutletContext]="{ $implicit: message }" />
        </div>
      } @else {
        <p class="bubble">{{ message.content }}</p>
      }
      @if (message.role === 'user') {
        <coin-employee-picture
          size="small"
          [gid]="userGid()" />
      }
    </div>
  }
  @if (isReplying()) {
    <div class="message">
      <div class="avatar assistant"></div>
      <div class="thinking-indicator">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
    </div>
  }
</div>
<ng-content />
